import { ChevronDown, ChevronRight, AlertTriangle } from "lucide-react";
import { useState } from "react";

import { brl, pct } from "../lib/periodos";
import DetalheDre from "./DetalheDre";

/**
 * Uma linha do DRE. O peso visual segue a hierarquia contábil: subtotal e
 * resultado puxam a atenção, detalhe fica recuado. Linha com `detalhe` abre no
 * clique — é onde o lojista descobre QUAIS despesas formaram o número, que é a
 * primeira pergunta que ele faz ao ver um total que não esperava.
 */
const ESTILO = {
  receita: "font-semibold text-base",
  deducao: "text-sm text-muted-foreground",
  subtotal: "font-bold text-base border-t bg-muted/40",
  custo: "text-sm",
  grupo: "font-semibold text-sm",
  despesa: "text-sm text-muted-foreground",
  alerta: "text-sm text-amber-600 dark:text-amber-500",
  resultado: "font-black text-lg border-t-2 bg-primary/5",
};

/**
 * Cor do número. Só o Resultado Líquido ganha verde/vermelho forte — é o único
 * que responde "deu lucro?". Despesa fica num vermelho apagado para pesar menos
 * que o resultado; o resto herda a cor do texto.
 */
function corDoValor(linha) {
  const v = Number(linha.valor);
  if (linha.tipo === "resultado") {
    return v >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400";
  }
  return v < 0 ? "text-red-600/80 dark:text-red-400/80" : "";
}

export default function LinhaDre({ linha }) {
  const [aberta, setAberta] = useState(false);
  const detalhe = (linha.detalhe || []).filter((d) => Number(d.valor) > 0);
  const temDetalhe = detalhe.length > 0;
  const lancamentos = detalhe.reduce((n, g) => n + (g.itens?.length || g.lancamentos || 0), 0);

  return (
    <>
      <div
        className={`flex items-center gap-3 px-4 py-2.5 ${ESTILO[linha.tipo] || ""} ${temDetalhe ? "cursor-pointer hover:bg-muted/60" : ""}`}
        onClick={temDetalhe ? () => setAberta((v) => !v) : undefined}
        data-e2e="dre-linha"
      >
        <div className="flex-1 flex items-center gap-1.5 min-w-0">
          {temDetalhe && (aberta ? <ChevronDown className="w-3.5 h-3.5 flex-shrink-0" /> : <ChevronRight className="w-3.5 h-3.5 flex-shrink-0" />)}
          {linha.tipo === "alerta" && <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" />}
          <span className="truncate whitespace-pre">{linha.rotulo}</span>
          {lancamentos > 0 && !aberta && (
            <span className="text-[10px] text-muted-foreground font-normal flex-shrink-0">({lancamentos})</span>
          )}
        </div>
        {linha.pct != null && (
          <span className="text-xs text-muted-foreground tabular-nums w-14 text-right flex-shrink-0">{pct(linha.pct)}</span>
        )}
        <span className={`tabular-nums text-right min-w-[8rem] whitespace-nowrap flex-shrink-0 ${corDoValor(linha)}`}>{brl(linha.valor)}</span>
      </div>
      {linha.nota && !aberta && <p className="px-4 pb-1.5 -mt-1 text-[11px] text-muted-foreground">{linha.nota}</p>}
      {aberta && <DetalheDre detalhe={detalhe} />}
    </>
  );
}
